import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-order-array',
  templateUrl: './order-array.component.html',
  styleUrls: ['./order-array.component.css'],
})
export class OrderArrayComponent implements OnInit {
  @Input() array: Array<{ name: string }>;

  @Output() save: EventEmitter<Array<any>> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  orderUp(element: any) {
    let oldIndex = this.array.indexOf(element);
    if (oldIndex <= 0) return;
    let newIndex = oldIndex - 1;

    let helper = [...this.array];
    helper[oldIndex] = this.array[newIndex];
    helper[newIndex] = this.array[oldIndex];
    this.array = helper;
  }

  orderDown(element: any) {
    let oldIndex = this.array.indexOf(element);
    if (oldIndex >= this.array.length - 1) return;
    let newIndex = oldIndex + 1;

    let helper = [...this.array];
    helper[oldIndex] = this.array[newIndex];
    helper[newIndex] = this.array[oldIndex];
    this.array = helper;
  }

  orderAlphabetically() {
    this.array = this.array.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
  }

  emitSaveEvent() {
    this.save.emit(this.array);
  }
}
